"use strict";

var _interopRequireWildcard = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _vue = require("vue");
var _core = require("echarts/core");
var _charts = require("echarts/charts");
var _components = require("echarts/components");
var _renderers = require("echarts/renderers");
var _vueEcharts = _interopRequireWildcard(require("vue-echarts"));
var _vueApi = require("@/utils/vueApi.js");
var _shop = require("@/api/shop.js");
var _default = {
  __name: 'deviceBattery',
  props: ['merchant-id'],
  setup: function setup(__props) {
    var _label2;
    var props = __props;
    (0, _core.use)([_components.TitleComponent, _components.TooltipComponent, _components.GridComponent, _charts.LineChart, _components.PolarComponent, _charts.BarChart, _renderers.CanvasRenderer, _components.LegendComponent, _components.ToolboxComponent, _components.MarkLineComponent, _components.MarkPointComponent]);
    (0, _vue.provide)(_vueEcharts.THEME_KEY, 'light');

    // 柜子设备数据--总数
    var deviceTotalNum = (0, _vue.ref)(0);
    var deviceInfo = (0, _vue.ref)([{
      title: '机柜总量(台)',
      num: '-',
      colorclass: 'bluefont',
      color: '#0066CC80'
    }, {
      title: '在线机柜(台)',
      num: '-',
      colorclass: 'greenfont',
      color: '#00B70080'
    }, {
      title: '离线机柜(台)',
      num: '-',
      colorclass: 'defaultfont',
      color: '#54678980'
    }]);
    //最近十天电池新增情况
    var batteryInData = (0, _vue.ref)([]);
    // 电池统计信息
    var batteryInfo = (0, _vue.ref)([{
      icon: 'iconA.png',
      num: '-',
      title: '电池总量'
    }, {
      icon: 'iconB.png',
      num: '-',
      title: '机柜中电池'
    }, {
      icon: 'iconG.png',
      num: '-',
      title: '使用中电池'
    }]);
    var store = (0, _vueApi.useStore)();
    (0, _vue.onMounted)(function () {
      console.log('onMounted', _core.graphic);
      // deviceTotalNum.value = deviceInfo.reduce((sum, item) => sum + item.num, 0)
      console.log('deviceTotalNum', deviceTotalNum.value);
      // return
      init();
    });
    var init = function init() {
      getDeviceInfo();
      getBatteryInfo();
      getBatteryInData();
    };
    var merchantId = (0, _vue.computed)(function () {
      return props.merchantId;
    });

    // Watch for changes in triggerApiCall and make API call
    (0, _vue.watch)(function () {
      return store.state.triggerApiCall;
    }, function () {
      // Make API call in ChildComponent1
      console.log('store.state.triggerApiCall', store.state.triggerApiCall);
      init();
    });
    var getBatteryInData = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var response;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _shop.getBatteryAddChartData)({
                  merchant_id: merchantId.value
                });
              case 3:
                response = _context.sent;
                console.log('getBatteryInData', response);
                batteryInData.value = response;
                chart2Option.value.xAxis.data = batteryInData.value.length > 0 ? batteryInData.value.map(function (item) {
                  return item.date;
                }) : [];
                chart2Option.value.series[0].data = batteryInData.value.length > 0 ? batteryInData.value.map(function (item) {
                  return item.num;
                }) : [];
                // handle the response here
                _context.next = 13;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.error('Error in getDeviceInfo:', _context.t0);
                // handle the error here
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));
      return function getBatteryInData() {
        return _ref.apply(this, arguments);
      };
    }();
    var getDeviceInfo = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var response;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _shop.getDeviceInfoChartData)({
                  merchant_id: merchantId.value
                });
              case 3:
                response = _context2.sent;
                console.log('getDeviceInfo', response);
                deviceInfo.value = response;
                deviceTotalNum.value = response[0].num;
                // handle the response here
                _context2.next = 12;
                break;
              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in getDeviceInfo:', _context2.t0);
                // handle the error here
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));
      return function getDeviceInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    var getBatteryInfo = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var response;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return (0, _shop.getBatteryChartData)({
                  merchant_id: merchantId.value
                });
              case 3:
                response = _context3.sent;
                console.log('response', response);
                batteryInfo.value = response;
                // handle the response here
                _context3.next = 11;
                break;
              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.error('Error in getBatteryInfo:', _context3.t0);
                // handle the error here
              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 8]]);
      }));
      return function getBatteryInfo() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getOption = function getOption(num, index) {
      var percentage = 0;
      if (num != '-') {
        percentage = num / deviceTotalNum.value * 100;
      }
      var colorMap = ['#0066CC80', '#00B70080', '#54678980'];
      var option = {
        title: {
          text: percentage.toFixed(0) + '%',
          textStyle: {
            fontSize: 22,
            // 修改字体大小
            color: '#546789'
          },
          // subtext: '总分：100分',
          subtextStyle: {
            color: '#546789'
          },
          itemGap: -10,
          // 主副标题距离
          left: 'center',
          top: 'center'
        },
        angleAxis: {
          max: 100,
          // 满分
          clockwise: false,
          // 逆时针
          // 隐藏刻度线
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        radiusAxis: {
          type: 'category',
          // 隐藏刻度线
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        polar: {
          center: ['50%', '50%'],
          radius: '170%' // 增加半径
        },

        series: [{
          type: 'bar',
          data: [{
            name: '作文得分',
            value: percentage,
            itemStyle: {
              normal: {
                color: colorMap[index]
                // color: graphic.LinearGradient(1, 0, 0, 0, [
                //     {
                //         offset: 0,
                //         color: color,
                //     },
                //     {
                //         offset: 1,
                //         color: '#0acfa1',
                //     },
                // ]),
              }
            }
          }],

          coordinateSystem: 'polar',
          roundCap: true,
          barWidth: 10,
          barGap: '-100%',
          // 两环重叠
          z: 2
        }, {
          // 灰色环
          type: 'bar',
          data: [{
            value: 100,
            itemStyle: {
              color: '#e2e2e2',
              shadowColor: 'rgba(0, 0, 0, 0.2)',
              shadowBlur: 5,
              shadowOffsetY: 2
            }
          }],
          coordinateSystem: 'polar',
          roundCap: true,
          barWidth: 10,
          barGap: '-100%',
          // 两环重叠
          z: 1
        }]
      };
      return option;
    };
    var defaultOption = (0, _vue.ref)({
      title: {
        text: '75%',
        textStyle: {
          fontSize: 22 // 修改字体大小
        },

        // subtext: '总分：100分',
        subtextStyle: {
          color: '#909090'
        },
        itemGap: -10,
        // 主副标题距离
        left: 'center',
        top: 'center'
      },
      angleAxis: {
        max: 100,
        // 满分
        clockwise: false,
        // 逆时针
        // 隐藏刻度线
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        splitLine: {
          show: false
        }
      },
      radiusAxis: {
        type: 'category',
        // 隐藏刻度线
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        splitLine: {
          show: false
        }
      },
      polar: {
        center: ['50%', '50%'],
        radius: '170%' // 增加半径
      },

      series: [{
        type: 'bar',
        data: [{
          name: '作文得分',
          value: 75,
          itemStyle: {
            normal: {
              color: _core.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: '#aaf14f'
              }, {
                offset: 1,
                color: '#0acfa1'
              }])
            }
          }
        }],
        coordinateSystem: 'polar',
        roundCap: true,
        barWidth: 15,
        barGap: '-100%',
        // 两环重叠
        z: 2
      }, {
        // 灰色环
        type: 'bar',
        data: [{
          value: 100,
          itemStyle: {
            color: '#e2e2e2',
            shadowColor: 'rgba(0, 0, 0, 0.2)',
            shadowBlur: 5,
            shadowOffsetY: 2
          }
        }],
        coordinateSystem: 'polar',
        roundCap: true,
        barWidth: 15,
        barGap: '-100%',
        // 两环重叠
        z: 1
      }]
    });
    // const chart2Option = (num, index) => {
    var chart2Option = (0, _vue.ref)({
      title: {
        text: '最近10天电池数据走向',
        textStyle: {
          fontSize: 16
        }
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {},
      toolbox: {
        show: false,
        feature: {
          dataZoom: {
            yAxisIndex: 'none'
          },
          dataView: {
            readOnly: false
          },
          magicType: {
            type: ['line', 'bar']
          },
          restore: {},
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: batteryInData.value.length > 0 ? batteryInData.value.map(function (item) {
          return item.date;
        }) : []
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value} 块'
        }
      },
      series: [{
        name: '电池',
        type: 'line',
        smooth: true,
        data: batteryInData.value.length > 0 ? batteryInData.value.map(function (item) {
          return item.num;
        }) : [],
        lineStyle: {
          color: '#0066CC80'
        },
        itemStyle: {
          color: '#0066CC80'
        },
        showSymbol: false,
        // 不显示实体点
        label: {
          show: true,
          // 显示值
          fontSize: 16,
          position: 'top',
          // 值的位置
          formatter: '{c}',
          // 值的格式
          color: '#0066CC80'
        },
        markPoint: {
          data: [{
            type: 'max',
            name: 'Max',
            itemStyle: {
              color: '#546789'
            }
          }, {
            type: 'min',
            name: 'Min',
            itemStyle: {
              color: '#ff6f6f'
            }
          }]
        },
        markLine: {
          data: [(0, _defineProperty2.default)({
            type: 'average',
            name: '平均值',
            lineStyle: {
              color: '#0066CC80'
            },
            label: (0, _defineProperty2.default)({
              show: true,
              // Ensure the label is shown
              position: 'middle',
              // Adjust the position of the label
              formatter: '平均值',
              // Set the text content of the label
              color: '#00b700'
            }, "formatter", function formatter(params) {
              return "".concat(params.name, ": ").concat(Math.round(params.value), " \u5757");
            })
          }, "lineStyle", {
            color: '#00b700'
          }), [{
            symbol: 'none',
            x: '90%',
            yAxis: 'max',
            lineStyle: {
              color: '#0066CC80'
            }
          }, {
            symbol: 'circle',
            label: (_label2 = {
              position: 'start',
              formatter: '最大值'
            }, (0, _defineProperty2.default)(_label2, "formatter", '{b}：{c}'), (0, _defineProperty2.default)(_label2, "color", '#0066CC80'), _label2),
            type: 'max',
            name: '最大值',
            itemStyle: {
              color: '#0066CC80'
            }
          }]]
        }
      }]
    });
    return {
      __sfc: true,
      deviceTotalNum: deviceTotalNum,
      deviceInfo: deviceInfo,
      batteryInData: batteryInData,
      batteryInfo: batteryInfo,
      store: store,
      init: init,
      props: props,
      merchantId: merchantId,
      getBatteryInData: getBatteryInData,
      getDeviceInfo: getDeviceInfo,
      getBatteryInfo: getBatteryInfo,
      getOption: getOption,
      defaultOption: defaultOption,
      chart2Option: chart2Option,
      VChart: _vueEcharts.default
    };
  }
};
exports.default = _default;